import {
  CustomerReason,
  CustomerReasonPagedList,
} from '@/libs/proof-approval/typings/Rejection/CustomerReason';
import { PrePressReason } from '@/libs/proof-approval/typings/Rejection/PrePressReason';
import { AxiosResponse } from 'axios';
import { createApi } from '../http/http-common';
import {
  authHandler,
  invalidTokenHandler,
  validTokenHandler,
} from './interceptor-handlers/AuthHandler';
import { Release } from '@/libs/proof-approval/typings/common/Feature';
import { ProductPrintData } from '@midocean/webapps-shared-domain';

const printConfigAPI = createApi({
  BASE_URL: process.env.VUE_APP_PRINT_CONFIG_BASE_URL,
});

// Setup interceptors for the printConfig API
printConfigAPI.interceptors.request.use(authHandler, function (error) {
  return Promise.reject(error);
});
printConfigAPI.interceptors.response.use(
  validTokenHandler,
  invalidTokenHandler
);

export default {
  get(uid: string): Promise<AxiosResponse<ProductPrintData>> {
    return printConfigAPI.get(
      `productPrintData/${uid}?includeCharacteristics=true&includeAiPreviewPrompt=true`
    );
  },
  getReasons(
    languageFilter: string
  ): Promise<{ data: CustomerReasonPagedList }> {
    return printConfigAPI.get(`customerReasons/`, {
      params: {
        languageFilter,
      },
    });
  },
  getCustomerReasonByCode(
    code: string
  ): Promise<AxiosResponse<CustomerReason>> {
    return printConfigAPI.get(`customerReasons/${code}`);
  },
  getPrePressReasonByCode(
    code: string
  ): Promise<AxiosResponse<PrePressReason>> {
    return printConfigAPI.get(`prePressReasons/${code}`);
  },
  getNewFeatures(
    versionId: number,
    languageFilter: string
  ): Promise<{ data: Release[] }> {
    return printConfigAPI.get(`releases/`, {
      params: {
        versionId,
        languageFilter,
      },
    });
  },
};
